module.exports = __webpack_public_path__ + "img/paramount-namesb.d0f0cf32.jpg";